import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { __UNSAFE_SPACE_TO_DIMSUM, toMobile, __UNSAFE_FONT_TO_DIMSUM } from '@elliemae/ds-system';
import { BOX_TYPES_ARRAY } from './constants.js';

var borderBase200 = function borderBase200(props) {
  return "1px solid ".concat(props.theme.colors.neutral[200], ";");
};

var categoryBoxStyles = "\n  width: 100%;\n  height: 36px;\n  padding:0 0;\n  color: ".concat(function (props) {
  return props.theme.colors.neutral[800];
}, ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border-bottom: ").concat(borderBase200, "\n");
var groupBoxStyles = "\n  border: unset;\n  font-size: ".concat(function (props) {
  return toMobile(props.theme.fontSizes[__UNSAFE_FONT_TO_DIMSUM(500)]);
}, ";\n  padding: 12px 0;\n");
var GroupBoxLabelNode = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-141ikkh-0"
})(["", " ", " ", " ", ""], function (props) {
  return props.nodeType === 'category-box' ? categoryBoxStyles : groupBoxStyles;
}, function (props) {
  return props.noBorder ? 'border: none;' : '';
}, function (props) {
  return props.borderBottom ? "border-bottom: ".concat(borderBase200(props)) : '';
}, function (props) {
  return props.isMain ? "padding-right: ".concat(__UNSAFE_SPACE_TO_DIMSUM(props.theme.space.xs), ";") : '';
});

function GroupBoxLabel(_ref) {
  var borderBottom = _ref.borderBottom,
      children = _ref.children,
      noBorder = _ref.noBorder,
      isMain = _ref.isMain,
      type = _ref.type,
      id = _ref.id;
  return /*#__PURE__*/React.createElement(GroupBoxLabelNode, {
    borderBottom: borderBottom,
    "data-testid": "ds-group-box__header",
    isMain: isMain,
    noBorder: noBorder,
    nodeType: type,
    id: id
  }, children);
}

GroupBoxLabel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  type: PropTypes.oneOf(BOX_TYPES_ARRAY),
  borderBottom: PropTypes.bool,
  isMain: PropTypes.bool.isRequired,
  noBorder: PropTypes.bool,
  id: PropTypes.string
};

export default GroupBoxLabel;
//# sourceMappingURL=GroupBoxLabel.js.map
